import React, { Component } from 'react';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import * as actions from "../../actions/ordersAction";
import * as symbols from "../../operations/symbols";
import CommonHeaderComponent from "../headers/CommonHeaderComponent";
import MultiImageUploaderComponent from '../core/MultiImageUploaderComponent';
import { USER_TYPE } from './../../operations/constants'

class InvoiceComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      photos: [],
      images: []
    }
  }

  componentDidMount() {
    this.props.actions.getOrderDetails(this.props.match.params.id);
  }

  filterInvoiceImages = () => {
    const { orderDetails =  {} } = this.props.orders;
    const { images = [] } = orderDetails;
    let invoiceImages = images.reduce((acc, ele) => {
      if (ele.entityType === 'invoice' && ele.userType === USER_TYPE.DA) {
        acc.push(ele)
      }
      return acc
    }, [])
    return invoiceImages;
  }
  componentDidUpdate(prevProps) {
    const { uploadImagesStatus, getOrdersStatus } = this.props;
    if (uploadImagesStatus !== prevProps.uploadImagesStatus && uploadImagesStatus === symbols.STATUS_DONE) {
      this.goToVerifyDelivery()
    }

    if (getOrdersStatus !== prevProps.getOrdersStatus && getOrdersStatus === symbols.STATUS_DONE) {
      let invoiceImages = this.filterInvoiceImages();
      this.setState({ images: invoiceImages })
    }
  }

  onSubmit = (payload) => {
    payload.set('imageType', 'invoice');
    payload.set('orderId', this.props.location.state.id);
    this.props.actions.uploadImages(payload, "invoiceImages");
  }

  goToVerifyDelivery = () => {
    const params = {
      entityId: parseInt(this.props.match.params.id),
      eventName: 'verify_products_complete'
    }
    this.props.actions.sendEvent(params);
    this.props.history.push({
      pathname: `/order/${this.props.match.params.id}/summary`,
      state: { id: this.props.match.params.id, orderNumber: this.props.location.state.orderNumber }
    })
  }

  render() {
    const { getOrdersStatus } = this.props;
    const invoiceImages = this.filterInvoiceImages();

    if (!this.props.location.state) {
      return (
        <React.Fragment>
          <CommonHeaderComponent title={`Invoice`} enableBack={true}/>
          <div className="pd-top-global fs-18 red-text center">
            Unauthorized!!!
          </div>
        </React.Fragment>
      )
    }

    return (
      <div className="pd-top-global gray-wrap mh-100">
        <CommonHeaderComponent title={`Invoice - ${this.props.location.state.id}`} enableBack={true}/>
        <MultiImageUploaderComponent
          imageType="invoice"
          uploadButtonText="Upload Invoice Images"
          orderId={this.props.location.state.id}
          onSubmit={this.onSubmit}
          uploadedImages={this.state.images.length ? this.state.images : invoiceImages}
          onSkipUpload={this.goToVerifyDelivery}
          selectedImages={this.props.orders.invoiceImages[this.props.location.state.id] ? this.props.orders.invoiceImages[this.props.location.state.id] : []}
        />
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    getOrdersStatus: state.statuses.getOrderDetails.status,
    getOrdersError: state.statuses.getOrderDetails.error,
    uploadImagesStatus: state.statuses.uploadImages.status,
    uploadImagesError: state.statuses.uploadImages.errors,
    orders: state.orders || {},
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(InvoiceComponent));
